module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/1wwSSQG0ZSqUQoMAwE0EWW-39ebe347349d57f7a0be9563abfcd19d.jpg";